module.exports = __webpack_public_path__ + "static/08-bb4f911d9662c1fb82741b5983f657f4.jpg";